import React, { useState } from "react";
import FlexWrapper from "../FlexWrapper";
import Typography from "../Typography";
import { Colors } from "../../Utils/Colors";
import { isMobile } from "../../Utils/IsMobile";
import { LinkedIn } from "../../Utils/SVGImages";
import hexToRGB from "../../Utils/hexToRGBA";

const TeamCard = ({ img, name, designation, linkedLink }) => {
  const [isHovered, setIsHovered] = useState(false);

  return (
    <div
      style={{
        width: "260px",
        borderRadius: "10px",
        overflow: "hidden",
        backgroundColor: "#fff",
        position: "relative",
        boxShadow: "0 10px 24px rgba(0,0,0,0.12)",
        transition: "transform 0.25s ease",
      }}
    >
      {/* Image Section */}
      <div
        style={{
          width: "100%",
          height: "320px",
          overflow: "hidden",
        }}
      >
        <img
          src={img}
          alt={name}
          style={{
            width: "100%",
            height: "100%",
            objectFit: "cover",
            display: "block",
          }}
        />
      </div>

      {/* Content Section */}
      <FlexWrapper
        flexDirection="column"
        alignItems="center"
        justifyContent="center"
        gap="6px"
        padding="14px 10px"
      >
        <Typography
          text={name}
          color={Colors.MirageBlack}
          sizeAndWeight={isMobile ? "1rem-600" : "1.1rem-600"}
        />
        <Typography
          text={designation}
          color={hexToRGB(Colors.MirageBlack, "0.7")}
          sizeAndWeight={isMobile ? "0.9rem-500" : "1rem-500"}
        />
      </FlexWrapper>

      {/* LinkedIn Icon – PERFECT CIRCLE */}
      <div
        style={{
          position: "absolute",
          top: "12px",
          right: "12px",
          width: "36px",
          height: "36px",
          borderRadius: "50%",
          backgroundColor: "#ffffff",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          cursor: "pointer",
          boxShadow: "0 4px 10px rgba(0,0,0,0.15)",
        }}
        onMouseEnter={() => setIsHovered(true)}
        onMouseLeave={() => setIsHovered(false)}
        onClick={() => window.open(linkedLink, "_blank")}
      >
        <LinkedIn
          fill={isHovered ? Colors.BigStone : "#646464"}
          width={18}
          height={18}
        />
      </div>
    </div>
  );
};

export default TeamCard;
